import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useNudge} from '../../hooks/use-nudge'
import {NudgeCard} from './NudgeCard'
import type {NudgePlacement} from '../../types/nudge'

interface TaskViewNudgeProps {
  taskCompleted: boolean
}

export function TaskViewNudge({taskCompleted}: TaskViewNudgeProps) {
  const placement: NudgePlacement = taskCompleted ? 'task_view_completion' : 'task_view_inline'
  const {activeNudge, dismiss, trackImpression, trackClick} = useNudge(placement)

  if (!isFeatureEnabled('copilot_mc_nudges') || !activeNudge) return null

  return (
    <NudgeCard nudge={activeNudge} onDismiss={dismiss} onImpression={trackImpression} onClick={trackClick} compact />
  )
}
